import { useEffect, useState } from "react";
import MainLayout from "../../components/layouts/MainLayout"
import { Link, useParams } from "react-router-dom";
import { providerApi } from "../../api/providerApi";
import { message } from "antd";
import { PlusCircleOutlined, MinusCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';


const UpdateProviderView = () => {
    const [loading, setLoading] = useState(false)
    // const [provider, setProvider] = useState('')
    const {id} = useParams()
    const abortController = new AbortController()
    const [formData, setFormData] = useState('')

    const handlefetchdata = async () => {
        setLoading(true)

        try {
            const res = await providerApi.getProvider(id,abortController.signal)

            // console.log(res)
 
            if(!res){
                setLoading(false)
                return message.error('Impossible de recuperer les donnees');
            }            
            setFormData({
                ...res.data,
                contacts: res.data.contacts || [""], // Gérer un tableau vide par défaut
              });
            setLoading(false)
            // console.log(formData)
 
         } catch (error) {
            //  console.log(error)
             message.error("Une erreur est survenue lors de la récupération des données")
            setLoading(false)
 
         }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);        
        // console.log(formData)
        try {
          const payload = {
            name:formData.name,
            lastname: formData.lastname,
            speciality: formData.speciality,
            adresse: formData.adresse,
            // ville: formData.ville,
            // photo: formData.photo,
          }
          const res = await providerApi.updateProvider(id, JSON.stringify(payload), abortController.signal);
          console.log(res)
          
          if (res.success == true) {
            message.success("Les informations ont été mises à jour avec succès !");
          }else{
            message.error(res.message);

          }
          setLoading(false);
        } catch (error) {
          console.error(error);
          setLoading(false);
          message.error("Échec de la mise à jour des informations");
        }
      };

      useEffect(()=> {
        handlefetchdata()
      },[id])

    return <MainLayout>
        <div className="flex justify-between">
            <h2 className="text-3xl font-semibold mb-6">Modifier un Prestataire</h2>
            <Link to={`/gestion-prestataires/liste`}><LeftCircleOutlined/> Retour  </Link>
        </div>
        <div className="max-w-lg mx-auto p-6 bg-white rounded-lg shadow-md">
        
      {/* <h2 className="text-2xl font-bold mb-4"></h2> */}
      <form onSubmit={handleSubmit}>
        {/* Informations Utilisateur */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Nom <span className="text-red-600 text-sm italic">(Obligatoire)</span> </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Prénom <span className="text-red-600 text-sm italic">(Obligatoire)</span></label>
          <input
            type="text"
            name="lastname"
            value={formData.lastname}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>   
        
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Spécialité</label>
          <input
            type="text"
            name="speciality"
            value={formData.speciality}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Ville </label>
          <input
            type="text"
            name="societeLieu"
            value={formData.ville}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Adresse </label>
          <input
            type="text"
            name="societeLieu"
            value={formData.adresse}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>

        {/* <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Catalogue </label>
          <input
            type="file"
            multiple
            name="photo"
            value={formData.photo}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div> */}


        {/* Soumission */}
        <div className="mt-6">
          <button
            type="submit"
            className="w-full px-4 py-2 bg-africasa-secondary text-white rounded-md hover:bg-africasa-primary"
            disabled={loading}
          >
            {loading ? 'Enregistrement...' : 'Modifier'}
          </button>
        </div>
      </form>
    </div>
    </MainLayout>
}

export default UpdateProviderView